import {makeType,actionCreator} from '../../Utils/generateActionCreator';

const actionType = makeType('PROSPECT');

export const ADD_ID_PROSPECTO = actionType('ADD_ID_PROSPECTO')
export const addIdProspecto = actionCreator(ADD_ID_PROSPECTO, 'idProspecto')